module.exports = __webpack_public_path__ + "img/nuki-app-activity-log.02ec32d9.png";